import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { isFullRowLeftToRightPath } from '../wordAnalysis'

export const straightForwardCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return (
    isAcceptedWordEntry(entry) &&
    isFullRowLeftToRightPath(entry.path, entry.boardCols, entry.boardRows)
  )
}
